(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("sbCurrenciesLib", [], factory);
	else if(typeof exports === 'object')
		exports["sbCurrenciesLib"] = factory();
	else
		root["sbCurrenciesLib"] = factory();
})(window, function() {
return 